import React, { useEffect, useState } from "react";
import "../Styles/Scroll.css";

import logo1 from "../../Asserts/1.png";
import logo2 from "../../Asserts/2.png";
import logo3 from "../../Asserts/3.png";
import logo4 from "../../Asserts/4.png";
import logo5 from "../../Asserts/5.png";
import logo6 from "../../Asserts/6.png";
import logo7 from "../../Asserts/7.png";
import logo8 from "../../Asserts/8.png";
import logo9 from "../../Asserts/9.png";
import logo10 from "../../Asserts/10.png";
import logo11 from "../../Asserts/11.png";
import logo12 from "../../Asserts/12.png";
import logo13 from "../../Asserts/13.png";
import logo14 from "../../Asserts/14.png";
import logo15 from "../../Asserts/15.png";
import logo16 from "../../Asserts/16.png";
import logo17 from "../../Asserts/17.png";
import logo18 from "../../Asserts/18.png";
import logo19 from "../../Asserts/19.png";
import logo20 from "../../Asserts/20.png";
import logo21 from "../../Asserts/21.png";
import logo22 from "../../Asserts/22.png";

const LOGOS = [
  logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8, logo9, logo10,
  logo11, logo12, logo13, logo14, logo15, logo16, logo17, logo18, logo19,
  logo20, logo21, logo22,
];

// Duplicate list for infinite loop
const infiniteLogos = [...LOGOS, ...LOGOS];

const ITEM_WIDTH = 160; // includes card + gap

const Scroll = () => {
  const [index, setIndex] = useState(0);

  // Auto slide
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % LOGOS.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  // Calculate the active positions (center, near-left, near-right)
  const getScaleClass = (i) => {
    const real = i % LOGOS.length;

    if (real === index) return "active-center";                    // main big
    if (real === (index + 1) % LOGOS.length) return "active-side"; // right medium
    if (real === (index - 1 + LOGOS.length) % LOGOS.length) return "active-side"; // left medium

    return ""; // others stay small
  };

  return (
    <div className="partner-section">
      <h2 className="partner-heading">
        We are a <span className="highlight-orange">Partner</span> to 100+ Leading Brands
      </h2>
      <p className="partner-subtitle">Trusted by industry leaders across manufacturing, energy, infrastructure, and technology sectors.</p>

      <div className="logo-slider-wrapper">
        <div
          className="slide-track-zoom"
          style={{ transform: `translateX(calc(50% - ${index * ITEM_WIDTH}px))` }}
        >
          {infiniteLogos.map((logo, i) => (
            <div className={`logo-card-zoom ${getScaleClass(i)}`} key={i}>
              <img src={logo} alt={`brand-${i}`} />
            </div>
          ))}
        </div>
      </div>
    </div>







  );
};

export default Scroll;
